/**!
 * Created by Leonardo Cheslacki on 05/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import PageController from './PageController';

import {HelpersIcon} from './../helpers';

import indexConfig from './../../../../config/index.config';

import pageConfig from './../../../../config/page.config';

import mainConfig from './../../../../config/main.config';

import WithType from './../WithType';

/**
 * REVIEW helpersIcon in all fla for color.
 */
class PageCurrent extends PageController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);

        this.props = props;
        this.main = main;

        this.state = {};

        this.$helpersIcon = HelpersIcon(this)({current_name: 'page'});

        PageCurrent._this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handle: function (event) {

        }
    };

    /**
     *
     * @returns {{paginates: (string|*), paginate: *, defaultPaginate: *}}
     */
    getPaginate = () => {
        const
            paginates = this.verifyField(this.getCurrentIndex(), 'paginates'),
            defaultPaginate = this.getDefaultIndex(paginates),
            paginate = this.getCurrentIndex(paginates) || defaultPaginate;

        return {defaultPaginate, paginate, paginates};
    };

    /**
     * Not usage direct.
     * @param execute
     */
    defaultInit = (execute = null) => {
        const
            {current_name, frame, color_icon} = this.props,
            _this_current = this.get();

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(_this_current, frame);

        this.pageIn();

        AllTap.emit('dynamic_frame', {frame: frame});

        this.$helpersIcon.setIcon(_this_current, color_icon);

        this.$helpersIcon.setIcon(this.getFrame(), color_icon);

        (typeof (execute) === 'function') && execute();

        /**
         * Preloader
         */
        AllTap.emit('process_end', {}, current_name);
    };

    initVacancies = () => {
        this.defaultInit(() => {
            const
                _this_frame = this.getFrame(),
                list = [
                    'ap11', 'ap12', 'ap21', 'ap22', 'ap31', 'ap32', 'ap41', 'ap42',
                    'ap51', 'ap52', 'ap61', 'ap62', 'ap71', 'ap72', 'ap81', 'ap82',
                    'ap91', 'ap92', 'ap101', 'ap102', 'ap111', 'ap112', 'ap121', 'ap122',
                    'ap131', 'ap132', 'ap141', 'ap142', 'ap151', 'ap152', 'ap161', 'ap162',
                    'ap171', 'ap172', 'ap181', 'ap182', 'ap191', 'ap192', 'ap201', 'ap202',
                    'ap211', 'ap212', 'ap221', 'ap222', 'ap231', 'ap232', 'ap241', 'ap242',
                    'ap251', 'ap252', 'ap261', 'ap262'
                ];

            list.forEach((nameVacancy) => {
                if (_this_frame[nameVacancy]) {
                    _this_frame[nameVacancy].name = nameVacancy;
                    _this_frame[nameVacancy].cursor = 'pointer';
                    _this_frame[nameVacancy].addEventListener('click', onClickVacancy.bind(_this_frame));
                }
            });

            if (_this_frame.btn_reset) {
                _this_frame.btn_reset.cursor = 'pointer';
                _this_frame.btn_reset.addEventListener('click', onClickReset.bind(_this_frame));
            }

            function onClickVacancy(evt) {
                let btn = evt.currentTarget,
                    container = btn.parent,
                    nameBtn = btn.name,
                    yAdjustment = 80,
                    screenCenterX = 1920 / 2;

                list.forEach((nameVacancy) => {
                    if (container[nameVacancy]) {
                        container[nameVacancy].gotoAndStop(0);
                    }
                });

                btn.gotoAndStop(1);

                let
                    plants = [container.occ_plant01, container.occ_plant02, container.occ_plant03],
                    activePlants = [],
                    inactivePlants = [];

                plants.forEach((plant) => {
                    if (plant) {
                        if (plant.origX === undefined) {
                            plant.origX = plant.x;
                            plant.origY = plant.y;
                            plant.origScaleX = plant.scaleX;
                            plant.origScaleY = plant.scaleY;
                        }

                        let isVacancy = false;
                        if (plant.occ_marker && plant.occ_marker.labels) {
                            for (let i = 0; i < plant.occ_marker.labels.length; i++) {
                                if (plant.occ_marker.labels[i].label === nameBtn) {
                                    isVacancy = true;
                                    break;
                                }
                            }
                        }

                        createjs.Tween.removeTweens(plant);

                        if (isVacancy) {
                            activePlants.push(plant);
                            plant.occ_marker.gotoAndStop(0);
                            plant.occ_marker.gotoAndStop(nameBtn);
                        } else {
                            inactivePlants.push(plant);
                        }
                    }
                });

                inactivePlants.forEach((plant) => {
                    createjs.Tween.get(plant).to({alpha: 0}, 300);
                });

                if (activePlants.length === 1) {
                    let
                        targetPlant = activePlants[0],
                        scale = 1.4,
                        plantWidth = targetPlant.nominalBounds.width * (targetPlant.origScaleX * scale),
                        finalX = screenCenterX - (plantWidth / 2);

                    createjs.Tween.get(targetPlant).to({
                        alpha: 1,
                        x: finalX,
                        y: targetPlant.origY - yAdjustment,
                        scaleX: targetPlant.origScaleX * scale,
                        scaleY: targetPlant.origScaleY * scale
                    }, 300);
                } else if (activePlants.length === 2) {
                    let
                        scale = 1.4,
                        gap = 15,
                        plant0Width = activePlants[0].nominalBounds.width * (activePlants[0].origScaleX * scale),
                        plant1Width = activePlants[1].nominalBounds.width * (activePlants[1].origScaleX * scale),
                        totalBlockWidth = plant0Width + gap + plant1Width,
                        startX = screenCenterX - (totalBlockWidth / 2);

                    createjs.Tween.get(activePlants[0]).to({
                        alpha: 1,
                        x: startX,
                        y: activePlants[0].origY - yAdjustment,
                        scaleX: activePlants[0].origScaleX * scale,
                        scaleY: activePlants[0].origScaleY * scale
                    }, 300);
                    createjs.Tween.get(activePlants[1]).to({
                        alpha: 1,
                        x: startX + plant0Width + gap,
                        y: activePlants[1].origY - yAdjustment,
                        scaleX: activePlants[1].origScaleX * scale,
                        scaleY: activePlants[1].origScaleY * scale
                    }, 300);
                } else if (activePlants.length === 3) {
                    activePlants.forEach((plant) => {
                        createjs.Tween.get(plant).to({
                            alpha: 1,
                            x: plant.origX,
                            y: plant.origY - yAdjustment,
                            scaleX: plant.origScaleX,
                            scaleY: plant.origScaleY
                        }, 300);
                    });
                }
            }

            /**
             *
             * @param event
             */
            function onClickReset(event) {
                let container = event.currentTarget.parent;

                list.forEach((nameVacancy) => {
                    if (container[nameVacancy]) {
                        container[nameVacancy].gotoAndStop(0);
                    }
                });

                let plants = [container.occ_plant01, container.occ_plant02, container.occ_plant03];

                plants.forEach((plant) => {
                    if (plant) {
                        if (plant.occ_marker) {
                            plant.occ_marker.gotoAndStop(0);
                        }

                        createjs.Tween.removeTweens(plant);

                        if (plant.origX !== undefined) {
                            createjs.Tween.get(plant).to({
                                alpha: 1,
                                x: plant.origX,
                                y: plant.origY,
                                scaleX: plant.origScaleX,
                                scaleY: plant.origScaleY
                            }, 300);
                        } else {
                            createjs.Tween.get(plant).to({alpha: 1}, 300);
                        }
                    }
                });
            }
        });
    };

    /**
     * Not usage direct.
     * @param execute
     * @param dynamic
     * @param current_page
     */
    defaultPaginateInit = (execute = null, dynamic = null, current_page = null) => {
        const
            {current_name, frame, color_icon} = this.props,
            stagePaginate = AllTap.$stagePaginate({current_name: current_name, current_page: current_page}),
            _this_current = this.get();

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(_this_current, frame);

        this.pageIn();

        stagePaginate.mainPaginate(dynamic);

        this.$helpersIcon.setIcon(_this_current, color_icon);

        this.$helpersIcon.setIcon(this.getFrame(), color_icon);

        (typeof (execute) === 'function') && execute(stagePaginate);

        /**
         * Preloader
         */
        AllTap.emit('process_end', {}, current_name);
    };

    /**
     * Single page.
     * Included helpersIcon color.
     */
    initCover = this.defaultInit;

    /**
     * Single page.
     * Included helpersIcon color.
     * For all pages simple.
     */
    initRecord = this.defaultInit;

    /**
     * Paginate.
     * Included helpersIcon color.
     * For all pages simple.
     */
    initPaginate = this.defaultPaginateInit;

    initMenu = () => {
        const {btn_menu01, btn_menu02} = AllTap.getState('_this_menu');

        this.setHandleMouseDown(btn_menu01, () => {
            this.pageOut();
            AllTap.$current_name_sub = 'planta01';
            AllTap.$current_frame_sub = 1;
        });

        this.setHandleMouseDown(btn_menu02, () => {
            this.pageOut();
            AllTap.$current_name_sub = 'planta02';
            AllTap.$current_frame_sub = 2;
        });

        /**
         * Preloader
         */
        AllTap.emit('process_end', {}, this.props.current_name);
    };

    initSlider = () => {
        this.defaultInit(() => {
            const
                _this_frame = this.getFrame(),
                listSlides = ['slide02', 'slide03', 'slide04'],
                btnPrev = _this_frame.btn_prev,
                btnNext = _this_frame.btn_next,
                isCarouselActive = listSlides.length > 3;

            let
                items = [],
                itemWidth = 630,
                visualStartX = 30,
                startX = visualStartX - itemWidth,
                totalWidth = listSlides.length * itemWidth,
                sliderOffset = 0,
                dragStartX = 0,
                initialOffset = 0,
                hasDragged = false,
                velocityX = 0,
                lastStageX = 0,
                isSnapping = false,
                targetOffset = 0;

            // Setup slides and initial positions
            listSlides.forEach((name, index) => {
                let item = _this_frame[name];

                if (item) {
                    item.name = name;
                    item.cursor = 'pointer';

                    let initialPosition = visualStartX + (index * itemWidth);

                    if (isCarouselActive) {
                        let normalizedPosition = ((initialPosition - startX) % totalWidth + totalWidth) % totalWidth;
                        item.origX = startX + normalizedPosition;
                    } else {
                        item.origX = initialPosition;
                    }

                    item.x = item.origX;

                    item.addEventListener('click', (evt) => {
                        if (hasDragged) return;
                        console.log('Clicked on slide: ', evt.currentTarget.name);
                    });

                    items.push(item);
                }
            });

            // ==========================================
            // 5. CAROUSEL ACTIVE CONDITION
            // ==========================================
            if (isCarouselActive) {

                // Drag core logic
                const onDragStart = (pointerX) => {
                    dragStartX = pointerX;
                    lastStageX = pointerX;
                    initialOffset = sliderOffset;
                    hasDragged = false;

                    createjs.Ticker.removeEventListener('tick', applyInertia);
                    velocityX = 0;
                    isSnapping = false;

                    if (_this_frame.drag_area) _this_frame.drag_area.cursor = 'grabbing';
                };

                const onDragMove = (pointerX) => {
                    let deltaX = pointerX - dragStartX;

                    velocityX = pointerX - lastStageX;
                    lastStageX = pointerX;

                    if (Math.abs(deltaX) > 10) {
                        hasDragged = true;
                    }

                    sliderOffset = initialOffset + deltaX;
                    updateCarousel();
                };

                const onDragEnd = () => {
                    if (_this_frame.drag_area) _this_frame.drag_area.cursor = 'grab';
                    createjs.Ticker.addEventListener('tick', applyInertia);
                };

                // CreateJS mouse events
                _this_frame.addEventListener('mousedown', (evt) => onDragStart(evt.stageX));
                _this_frame.addEventListener('pressmove', (evt) => onDragMove(evt.stageX));
                _this_frame.addEventListener('pressup', () => onDragEnd());

                // Native DOM touch events
                if (stage && stage.canvas) {
                    const canvasEl = stage.canvas;

                    canvasEl.style.touchAction = 'none';
                    canvasEl.style.msTouchAction = 'none';

                    const getCanvasTouchX = (evt) => {
                        let rect = canvasEl.getBoundingClientRect();
                        let touch = evt.targetTouches[0];
                        return (touch.clientX - rect.left) / (rect.width / canvasEl.width);
                    };

                    canvasEl.addEventListener('touchstart', (evt) => {
                        if (evt.targetTouches.length === 1) {
                            onDragStart(getCanvasTouchX(evt));
                        }
                    }, {passive: false});

                    canvasEl.addEventListener('touchmove', (evt) => {
                        evt.preventDefault();
                        if (evt.targetTouches.length === 1) {
                            onDragMove(getCanvasTouchX(evt));
                        }
                    }, {passive: false});

                    canvasEl.addEventListener('touchend', (evt) => {
                        onDragEnd();
                    }, {passive: false});
                }

                if (_this_frame.drag_area) {
                    _this_frame.drag_area.cursor = 'grab';
                }

                // Momentum and snap logic
                function applyInertia() {
                    if (Math.abs(velocityX) < 2 && !isSnapping) {
                        isSnapping = true;
                        targetOffset = Math.round(sliderOffset / itemWidth) * itemWidth;
                    }

                    if (isSnapping) {
                        let difference = targetOffset - sliderOffset;
                        sliderOffset += difference * 0.15;

                        if (Math.abs(difference) < 0.5) {
                            sliderOffset = targetOffset;
                            createjs.Ticker.removeEventListener('tick', applyInertia);
                            isSnapping = false;
                        }
                    } else {
                        sliderOffset += velocityX;
                        velocityX *= 0.96;
                    }

                    updateCarousel();
                }

                // Infinite loop positioning
                function updateCarousel() {
                    items.forEach((item) => {
                        let newPositionX = item.origX + sliderOffset;
                        let normalizedPosition = ((newPositionX - startX) % totalWidth + totalWidth) % totalWidth;
                        item.x = startX + normalizedPosition;
                    });
                }

                // Navigation buttons setup
                if (btnPrev) {
                    btnPrev.visible = true;
                    btnPrev.cursor = 'pointer';
                    btnPrev.addEventListener('click', () => {
                        targetOffset = Math.round(sliderOffset / itemWidth) * itemWidth + itemWidth;
                        isSnapping = true;
                        velocityX = 0;
                        createjs.Ticker.addEventListener('tick', applyInertia);
                    });
                }

                if (btnNext) {
                    btnNext.visible = true;
                    btnNext.cursor = 'pointer';
                    btnNext.addEventListener('click', () => {
                        targetOffset = Math.round(sliderOffset / itemWidth) * itemWidth - itemWidth;
                        isSnapping = true;
                        velocityX = 0;
                        createjs.Ticker.addEventListener('tick', applyInertia);
                    });
                }

                updateCarousel();

            } else {
                // ==========================================
                // 6. CAROUSEL INACTIVE (3 OR FEWER SLIDES)
                // ==========================================

                if (btnPrev) btnPrev.visible = false;
                if (btnNext) btnNext.visible = false;

                if (_this_frame.drag_area) _this_frame.drag_area.cursor = 'default';

                if (stage && stage.canvas) {
                    stage.canvas.style.touchAction = 'auto';
                    stage.canvas.style.msTouchAction = 'auto';
                }
            }
        });
    };

    initPortal = () => {
        this.defaultInit(() => {
            const {btn_01, btn_02} = this.getFrame();

            this.setHandleMouseDown(btn_01, () => {
                window.open('http://reserva-web.local', '_self');
            });

            this.setHandleMouseDown(btn_02, () => {
                window.open('http://reserva-bosque-web.local', '_self');
            });
        });
    };

    /**
     * Single page.
     * Included stageGallery and helpersIcon color.
     */
    initGallery = () => {
        this.defaultInit(() => {
            AllTap.$stageGallery({
                current_name: this.props.current_name,
                xml: this.verifyField(this.getCurrentIndex(), 'xml')
            }).mainGallery();
        });
    };

    initProduct = () => {
        this.defaultInit(() => {
            const
                _this_frame = this.getFrame(),
                btn_change = this.verifyField(_this_frame, 'btn_change');

            this.setStateOccurrence(btn_change, {active: false});

            const execute = (event) => {
                let
                    occ_image = this.verifyField(_this_frame, 'occ_image'),
                    occ_icon_change = this.verifyField(_this_frame, 'occ_icon_change'),
                    isActive = this.getStateOccurrence(event.currentTarget, 'active');

                occ_icon_change.occ_more.visible = isActive;
                occ_icon_change.occ_less.visible = !isActive;

                if (isActive === false) {
                    this.setStateOccurrence(event.currentTarget, {active: true});

                    this.effectFadeOut(_this_frame, 'occ_image', () => {
                        this.gotoAndStopFrame(occ_image, 2);
                        this.effectFadeIn(_this_frame, 'occ_image');
                    });
                } else {
                    this.setStateOccurrence(event.currentTarget, {active: false});

                    this.effectFadeOut(_this_frame, 'occ_image', () => {
                        this.gotoAndStopFrame(occ_image, 1);
                        this.effectFadeIn(_this_frame, 'occ_image');
                    });
                }
            };

            btn_change && this.setHandleMouseDown(btn_change, execute);
        });
    };

    /**
     * Paginate.
     * Included stageGallery and helpersIcon color.
     * @param current_page
     */
    initGalleryPaginate = (current_page) => {
        this.defaultPaginateInit(() => {
            const
                {current_name} = this.props,
                {defaultPaginate, paginate} = this.getPaginate();

            if (this.inArray([2, 3], paginate.frame)) {
                AllTap.$stageGallery({
                    current_name: current_name,
                    xml: this.verifyField(this.getCurrentIndex(), 'xml')
                }).mainGallery();

                const anim_container = document.getElementById('animation_container');

                AllTap.$element_img = document.createElement('IMG');

                this.setAttributes(AllTap.$element_img, {
                    id: 'close_overlay_container',
                    alt: 'close',
                    src: this.getUriImage('close.png'),
                    width: this.calcSize(1, stage.scaleX, 40, false, 'int'),
                    height: this.calcSize(1, stage.scaleY, 40, false, 'int')
                });

                const close = () => {
                    this.removeListener('click', 'click-close-overlay-container');

                    this.pageOut();

                    AllTap.$current_name_sub = this.verifyField(defaultPaginate, 'name');
                    AllTap.$current_frame_sub = this.verifyField(defaultPaginate, 'frame');
                    AllTap.$element_img.remove();
                };

                this.removeListener('click', 'click-close-overlay-container', () => {
                    this.addListener(AllTap.$element_img, 'click', 'click-close-overlay-container', close);
                });

                anim_container.appendChild(AllTap.$element_img);
            }
        });
    };

    /**
     * Single page.
     * Included stagePin and helpersIcon color.
     */
    initImplantation = () => {
        this.defaultInit(() => {
            const paginate = this.getCurrentIndex();
            AllTap.$stagePin({
                current_name: this.props.current_name,
                xml: this.verifyField(paginate, 'xml'),
                content_text: this.verifyField(paginate, 'content_text')
            }).mainPin();
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initImplantationPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            AllTap.$stagePin({
                current_name: current_name,
                xml: this.verifyField(paginate, 'xml'),
                content_text: this.verifyField(paginate, 'content_text'),
                extra: this.verifyField(paginate, 'extra')
            }).mainPin();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initPaginateLocalization = () => {
        this.defaultPaginateInit(() => {
            const {
                btn_tour
            } = this.getFrame();

            const execute = (event, options) => {
                let occ_button = this.getObject(options, 'occ_button');
                this.openTour(occ_button, options);
            };

            this.setHandleMouseDown(btn_tour, execute, {
                occ_button: btn_tour,
                name: 'tour-01',
                uri: 'app/tour-localizacao'
            });
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initDifferentialPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Paginate.
     * Included stagePaginate, layerDifferential, layerCamera, layerPin and helpersIcon color.
     */
    initPlantPaginate = () => {
        this.defaultPaginateInit((stagePaginate) => {
            const
                _this_current = this.get(),
                {current_name, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            // if (paginate.frame === 2) {
            //     AllTap.$stageGallery({
            //         current_name: current_name,
            //         xml: this.verifyField(paginate, 'xml')
            //     }).mainGallery();
            // }

            if (this.verifyField(paginate, 'active.differential')) {
                const layerDifferential = AllTap.$layerDifferential({
                    current_name: current_name,
                    enabled: this.verifyField(paginate, 'active.differential_enabled')
                });
                layerDifferential.mainDifferential();
                stagePaginate.setState({...stagePaginate.state, differential: layerDifferential});
            }

            if (this.verifyField(paginate, 'active.camera')) {
                const layerCamera = AllTap.$layerCamera({current_name: current_name});
                layerCamera.mainCamera();
                stagePaginate.setState({...stagePaginate.state, camera: layerCamera});
            }

            if (this.verifyField(paginate, 'active.pin')) {
                const layerPin = AllTap.$layerPin({current_name: current_name});
                layerPin.mainPin();
                stagePaginate.setState({...stagePaginate.state, pin: layerPin});
            }

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    initLocalizationDynamic = () => {
        this.defaultPaginateInit(() => {
            this.main.on('dynamic_paginate', ({number_current, current_name}) => {
                const
                    _this_frame = this.getFrame(),
                    {occ_convenience, occ_pseudo} = _this_frame;

                if (current_name === this.props.current_name) {
                    if (number_current === 2) {
                        occ_convenience.gotoAndStop('empty');
                        occ_pseudo.gotoAndStop('empty');
                        occ_convenience.btn_close.visible = false;

                        this.setHandleMouseDown(occ_convenience.btn_close, () => {
                            this.effectFadeOut(_this_frame, 'occ_convenience', () => {
                                occ_convenience.gotoAndStop('empty');
                                occ_pseudo.gotoAndStop('empty');
                                occ_convenience.btn_close.visible = false;
                            });
                        });

                        for (let i = 1; i < 8; i++) {
                            let occ = _this_frame[`btn_${this.padWithLeadingZeros(i, 2)}`];
                            this.setHandleMouseDown(occ, () => {
                                this.effectFadeIn(_this_frame, 'occ_convenience');
                                this.gotoAndStopFrame(occ_convenience, i);
                                this.gotoAndStopFrame(occ_pseudo, i);
                                occ_convenience.btn_close.visible = true;
                            });
                        }
                    }
                }
            }, this.props.current_name);
        }, true);
    };

    initLocalizationPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name} = this.props,
                {paginate} = this.getPaginate();

            if (paginate.frame === 1) {
                AllTap.$stageLocalization({
                    current_name: current_name,
                    xml: this.verifyField(paginate, 'xml')
                }).mainLocalization();
            } else if (paginate.frame === 2) {
                const
                    buttons = this.verifyField(_this_current, 'occ_frame_01.occ_marker.occ_buttons.children'),
                    markers = this.verifyField(_this_current, 'occ_frame_01.occ_marker.occ_markers');

                let current_btn, current_marker;

                const showMarker = function (event) {
                    const {button, marker} = this;

                    if (current_btn === button) {
                        current_btn.gotoAndPlay('off');
                        current_marker.gotoAndPlay('off');
                        current_btn = '';
                        current_marker = '';

                        return;
                    } else if (current_btn) {
                        current_btn.gotoAndPlay('off');
                        current_marker.gotoAndPlay('off');
                    }

                    current_btn = button;
                    current_marker = marker;
                    button.gotoAndPlay('on');
                    marker.gotoAndPlay('on');
                }

                buttons.forEach((button) => {
                    const
                        btn_number = parseInt(button.name.split('_')[1]),
                        number = (btn_number < 10) ? `0${btn_number}` : btn_number,
                        marker = markers[`occ_marker_${number}`];

                    button.gotoAndPlay('off');
                    marker.gotoAndPlay('off');
                    button.btn.removeEventListener('click', showMarker);
                    button.btn.addEventListener('click', showMarker.bind({button, marker}));
                });
            } else if (paginate.frame === 3) {
                AllTap.$stageSlider({current_name: current_name, composition_name: paginate.name}).mainSlider();
            }
        });
    };

    initConveniencePaginate = () => {
        this.defaultPaginateInit(() => {
            const
                {btn_video} = this.get(),
                {current_name, current_page} = this.props;

            AllTap.$stageSlider({current_name, current_page}).mainSlider();

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video, execute, {
                occ_button: btn_video,
                name: 'video',
                uri: 'example.mp4'
            });
        }, 1);
    };

    initPanoramicPaginate = () => {
        this.defaultPaginateInit(() => {
            const {btn_video} = this.get();

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video, execute, {
                occ_button: btn_video,
                name: 'video',
                uri: 'example.mp4'
            });
        }, 2);
    };

    initMapPaginate = () => {
        this.defaultPaginateInit(() => {
            const {btn_video} = this.get();

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video, execute, {
                occ_button: btn_video,
                name: 'video',
                uri: 'example.mp4'
            });
        }, 3);
    };

    initMap = () => {
        this.defaultPaginateInit(() => {
            const
                {show_map_tool} = mainConfig.map,
                current_name = this.props.current_name;

            AllTap.$stageMapSelector({current_name}).initMapSelector();

            if (show_map_tool) { // Set show_map_tool=true in order to render map helper tool (for development only).
                AllTap.$stageMapTool({current_name}).makeTest();
            }
        });
    };

    initVideoPaginate = () => {
        this.defaultPaginateInit(() => {
            const {btn_video} = this.get();

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video, execute, {
                occ_button: btn_video,
                name: 'video',
                uri: 'example.mp4'
            });
        });
    };

    /**
     * REVIEW
     * Single page.
     * Included helpersIcon color.
     */
    initProject = () => {
        this.defaultInit(() => {
            const
                {occ_project: {occ_project_01, occ_project_02, occ_project_03}} = this.getFrame(),
                {color_icon} = this.props;

            this.setHandleMouseDown(occ_project_01.btn_more, () => {
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_01.gotoAndPlay('start');
            }, null, `${occ_project_01.name}_more`);

            this.setHandleMouseDown(occ_project_01.btn_less, () => {
                occ_project_01.gotoAndPlay('complete');
            }, null, `${occ_project_01.name}_less`);

            this.$helpersIcon.setIcon(occ_project_01, color_icon);
            this.$helpersIcon.setIcon(occ_project_01.btn_more, color_icon);

            this.setHandleMouseDown(occ_project_02.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_02.gotoAndPlay('start');
            }, null, `${occ_project_02.name}_more`);

            this.setHandleMouseDown(occ_project_02.btn_less, () => {
                occ_project_02.gotoAndPlay('complete');
            }, null, `${occ_project_02.name}_less`);

            this.$helpersIcon.setIcon(occ_project_02, color_icon);
            this.$helpersIcon.setIcon(occ_project_02.btn_more, color_icon);

            this.setHandleMouseDown(occ_project_03.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');

                occ_project_03.gotoAndPlay('start');
            }, null, `${occ_project_03.name}_more`);

            this.setHandleMouseDown(occ_project_03.btn_less, () => {
                occ_project_03.gotoAndPlay('complete');
            }, null, `${occ_project_03.name}_less`);

            this.$helpersIcon.setIcon(occ_project_03, color_icon);
            this.$helpersIcon.setIcon(occ_project_03.btn_more, color_icon);
        });
    };

    initProjectPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                {occ_project: {occ_project_01, occ_project_02, occ_project_03}} = this.getFrame(),
                {color_icon} = this.props;

            this.setHandleMouseDown(occ_project_01.btn_more, () => {
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_01.gotoAndPlay('start');
            }, null, `${occ_project_01.name}_more`);

            this.setHandleMouseDown(occ_project_01.btn_less, () => {
                occ_project_01.gotoAndPlay('complete');
            }, null, `${occ_project_01.name}_less`);

            this.$helpersIcon.setIcon(occ_project_01, color_icon);
            this.$helpersIcon.setIcon(occ_project_01.btn_more, color_icon);

            this.setHandleMouseDown(occ_project_02.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_02.gotoAndPlay('start');
            }, null, `${occ_project_02.name}_more`);

            this.setHandleMouseDown(occ_project_02.btn_less, () => {
                occ_project_02.gotoAndPlay('complete');
            }, null, `${occ_project_02.name}_less`);

            this.$helpersIcon.setIcon(occ_project_02, color_icon);
            this.$helpersIcon.setIcon(occ_project_02.btn_more, color_icon);

            this.setHandleMouseDown(occ_project_03.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');

                occ_project_03.gotoAndPlay('start');
            }, null, `${occ_project_03.name}_more`);

            this.setHandleMouseDown(occ_project_03.btn_less, () => {
                occ_project_03.gotoAndPlay('complete');
            }, null, `${occ_project_03.name}_less`);

            this.$helpersIcon.setIcon(occ_project_03, color_icon);
            this.$helpersIcon.setIcon(occ_project_03.btn_more, color_icon);
        });
    };

    // initProjectPaginate = () => {
    //     this.defaultPaginateInit(() => {
    //         const
    //             _this_current = this.get(),
    //             _this_frame = this.getFrame(),
    //             {current_name, color_icon} = this.props,
    //             {paginate, paginates} = this.getPaginate();
    //
    //         if (paginate.frame === 1) {
    //             _this_frame.occ_sector.gotoAndPlay('sector01');
    //
    //             let children = this.verifyField(_this_frame, 'occ_button.children');
    //
    //             if (this.isArrayIf(children)) {
    //                 for (let property of children) {
    //                     this.setHandleMouseDown(property, () => {
    //                         _this_frame.occ_sector.gotoAndPlay(`sector${this.padWithLeadingZeros(this.toNumber(property.name), 2)}`);
    //                     });
    //                 }
    //             }
    //         } else if (this.inArray([2, 6], paginate.frame)) {
    //             AllTap.$stagePin({
    //                 current_name: current_name,
    //                 xml: this.verifyField(paginate, 'xml'),
    //                 content_text: this.verifyField(paginate, 'content_text')
    //             }).mainPin();
    //         } else if (this.inArray([3, 7, 8, 9], paginate.frame)) {
    //             for (let property of paginates) {
    //                 this.$helpersIcon.setIcon(_this_current, (paginate.frame === property.frame ? '0xFFFFFF' : color_icon), property.frame);
    //             }
    //
    //             this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
    //         }
    //     });
    // };

    initOdometer = () => {
        this.defaultInit(() => {
            const {occ_effect_01: {occ_odometer_01, occ_odometer_02, occ_odometer_03}} = this.getFrame();

            let
                originalY01 = this.getStateOccurrence(occ_odometer_01, 'state.originalY'),
                originalY02 = this.getStateOccurrence(occ_odometer_02, 'state.originalY'),
                originalY03 = this.getStateOccurrence(occ_odometer_03, 'state.originalY');

            if (!originalY01) {
                originalY01 = occ_odometer_01.y;
                this.setStateOccurrence(occ_odometer_01, {originalY: originalY01});
            }

            if (!originalY02) {
                originalY02 = occ_odometer_02.y;
                this.setStateOccurrence(occ_odometer_02, {originalY: originalY02});
            }

            if (!originalY03) {
                originalY03 = occ_odometer_03.y;
                this.setStateOccurrence(occ_odometer_03, {originalY: originalY03});
            }

            occ_odometer_01.y = (originalY01 + 15);

            occ_odometer_02.y = (originalY02 + 15);

            occ_odometer_03.y = (originalY03 + 10);

            this.odometer(occ_odometer_01, 60, true, () => {
                this.odometer(occ_odometer_02, 6800, true, () => {
                    this.odometer(occ_odometer_03, 1500000, true);
                });
            });
        });
    };

    initRationalPaginate = () => {
        this.defaultPaginateInit();
        // this.defaultPaginateInit((stagePaginate) => {
        //     AllTap.on('dynamic_paginate', ({number_current, current_name}) => {
        //         if(current_name === this.props.current_name){
        //             if (number_current === 2) {
        //                 const _this_frame = this.getFrame();
        //
        //                 let children = this.verifyField(_this_frame, 'occ_card.occ_button.children');
        //
        //                 if (this.isArrayIf(children)) {
        //                     for (let property of children) {
        //                         this.setHandleMouseDown(property, () => {
        //                             _this_frame.occ_card.gotoAndStop(`card${this.padWithLeadingZeros(this.toNumber(property.name), 2)}`);
        //                         });
        //                     }
        //                 }
        //             }
        //         }
        //     }, this.props.current_name);
        // }, true);
    };

    initInstitutionalPaginate = () => {
        this.defaultPaginateInit(() => {

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            AllTap.on('dynamic_paginate', ({number_current, current_name}) => {
                if (current_name === this.props.current_name) {
                    if (number_current === 2) {
                        AllTap.$stageSlider({
                            current_name: this.props.current_name,
                            composition_name: this.props.current_name
                        }).mainSlider();
                    } else if (number_current === 3) {
                        let {btn_video01} = this.getFrame();

                        this.setHandleMouseDown(btn_video01, execute, {
                            occ_button: btn_video01,
                            name: 'video-01',
                            uri: 'vr-girl.mp4'
                        });
                    }
                }
            }, this.props.current_name);

        }, true);
    };

    /**
     * Paginate.
     * Included stagePaginate, stageView and helpersIcon color.
     */
    initView = () => {
        this.defaultPaginateInit(() => {
            const {current_name} = this.props;
            AllTap.$stageView({
                current_name: current_name,
                xml: this.verifyField(this.getCurrentIndex(), 'xml'),
            }).initView();
        }, true);
    };

    /**
     * Single page.
     * Included stageSun and helpersIcon color.
     */
    initOrientation = () => {
        this.defaultInit(() => {
            // Handle btn orientacao switch (between two frames)
            const
                {current_name} = this.props,
                {btn_orientacao, occ_plant: {occ_effect}} = this.getFrame();

            let current_frame = 'frame01';

            AllTap.$stageSun({current_name: current_name}).mainSun();

            this.setHandleMouseDown(btn_orientacao, () => {
                // switch between frame 1 and 2
                current_frame = (current_frame === 'frame01') ? 'frame02' : 'frame01';
                occ_effect.occ_light.gotoAndStop(current_frame);
                occ_effect.occ_night.gotoAndStop(current_frame);
                occ_effect.occ_shadow.gotoAndStop(current_frame);
            });
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initOrientationPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, current_page, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            AllTap.$stageSun({current_name, current_page}).mainSun();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Single page.
     * Included stageZoom and helpersIcon color.
     */
    initZoom = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stageZoom({current_name}).mainZoom();
        });
    };

    /**
     * Paginate.
     * Included stageZoom and helpersIcon color.
     */
    initZoomPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, current_page, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            AllTap.$stageZoom({current_name, current_page}).mainZoom();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    // /**
    //  * Single page.
    //  * Included stageSlider and helpersIcon color.
    //  */
    // initSlider = () => {
    //     this.defaultInit(() => {
    //         const {current_name} = this.props;
    //         AllTap.$stageSlider({current_name: current_name, composition_name: current_name}).mainSlider();
    //     });
    // };

    /**
     * Single page.
     * Included stageScroll and helpersIcon color.
     */
    initScroll = () => {
        this.defaultInit(() => {
            AllTap.$stageScroll({current_name: this.props.current_name}).mainScroll();
        });
    };

    /**
     * Single page.
     * Included stageQuiz and helpersIcon color.
     */
    initQuiz = () => {
        this.defaultInit(() => {
            AllTap.$stageQuiz({current_name: this.props.current_name}).mainQuiz();
        });
    };

    /**
     * Single page.
     * Included stageMemory and helpersIcon color.
     */
    initMemory = () => {
        this.defaultInit(() => {
            AllTap.$stageMemory({current_name: this.props.current_name}).mainMemory();
        });
    };

    /**
     * Single page.
     * Included stageMarquee and helpersIcon color.
     */
    initMarquee = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stageMarquee({current_name: current_name}).mainMarquee();
        });
    };

    /**
     * Single page.
     * Included stage360 and helpersIcon color.
     */
    init360 = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stage360({current_name: current_name}).main360();
        });
    };

    /**
     * REVIEW
     */
    initVideo = () => {
        this.defaultInit(() => {
            const {
                btn_video01,
                btn_video02,
                btn_video03,
                btn_video04,
                btn_video05,
                btn_video06
            } = this.getFrame();

            const execute = (event, options) => {
                let occ_button = this.getObject(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video01, execute, {
                occ_button: btn_video01,
                name: 'video-01',
                uri: 'doctor.mp4'
            });

            this.setHandleMouseDown(btn_video02, execute, {
                occ_button: btn_video02,
                name: 'video-02',
                uri: 'example.mp4'
            });

            this.setHandleMouseDown(btn_video03, execute, {
                occ_button: btn_video03,
                name: 'video-03',
                uri: 'vr-boy.mp4'
            });

            this.setHandleMouseDown(btn_video04, execute, {
                occ_button: btn_video04,
                name: 'video-04',
                uri: 'vr-girl.mp4'
            });

            this.setHandleMouseDown(btn_video05, execute, {
                occ_button: btn_video05,
                name: 'video-05',
                uri: 'doctor.mp4'
            });

            this.setHandleMouseDown(btn_video06, execute, {
                occ_button: btn_video06,
                name: 'video-06',
                uri: 'example.mp4'
            });
        });
    };

    /**
     * REVIEW
     */
    initTour = () => {
        this.defaultInit(() => {
            const {
                btn_video01,
                btn_video02
            } = this.getFrame();

            const execute = (event, options) => {
                let occ_button = this.getObject(options, 'occ_button');
                this.openTour(occ_button, options);
            };

            this.setHandleMouseDown(btn_video01, execute, {
                occ_button: btn_video01,
                name: 'video-01',
                uri: 'https://dlightvr.com.br/fibra/florida/36_studio'
            });

            this.setHandleMouseDown(btn_video02, execute, {
                occ_button: btn_video02,
                name: 'video-02',
                uri: 'https://dlightvr.com.br/fibra/florida/33_apto/'
            });
        });
    };

    initImplantationAndOrientation = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, current_page, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            if (current_page === 'implantacao') {
                AllTap.$stagePin({
                    current_name: current_name,
                    xml: this.verifyField(paginate, 'xml'),
                    content_text: this.verifyField(paginate, 'content_text')
                }).mainPin();

                this.destroyTicker('_handleZoom');
            } else if (current_page === 'orientacao') {
                AllTap.$stageSun({
                    current_name: current_name,
                    current_page: current_page
                }).mainSun();

                this.destroyTicker('_handleZoom');
            } else if (current_page === 'planta') {
                AllTap.$stageZoom({current_name: current_name}).mainZoom();
            }

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * REVIEW
     * Paginate.
     * Included stagePaginate and helpersIcon color.
     */
    initSlide = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {color_icon} = this.props,
                occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
                btn_frame = this.verifyField(_this_current, 'btn_frame01');

            this.$helpersIcon.disabledAnimate(_this_current)(1, 'frame');

            this.$helpersIcon.setIcon(_this_current, color_icon, 1);

            this.$helpersIcon.setIcon(_this_current, color_icon, 2);

            this.$helpersIcon.setIcon(_this_current, color_icon, 3);

            occ_pseudo_frame && (occ_pseudo_frame.visible = true);

            btn_frame && (btn_frame.visible = false);
        }, true);
    };

    // initSector = () => {
    //     this.defaultInit(() => {
    //         const {occ_line, btn_01, btn_02, btn_03, btn_04, btn_06} = this.getFrame();
    //
    //         this.setHandleMouseDown(btn_01, () => {
    //             this.gotoAndStopFrame(occ_line, 1);
    //             occ_line.occ_01.gotoAndPlay('start');
    //         });
    //
    //         this.setHandleMouseDown(btn_02, () => {
    //             this.gotoAndStopFrame(occ_line, 2);
    //             occ_line.occ_02.gotoAndPlay('start');
    //         });
    //
    //         this.setHandleMouseDown(btn_03, () => {
    //             this.gotoAndStopFrame(occ_line, 3);
    //             occ_line.occ_03.gotoAndPlay('start');
    //         });
    //
    //         this.setHandleMouseDown(btn_04, () => {
    //             this.gotoAndStopFrame(occ_line, 4);
    //             occ_line.occ_04.gotoAndPlay('start');
    //         });
    //
    //         this.setHandleMouseDown(btn_06, () => {
    //             this.gotoAndStopFrame(occ_line, 6);
    //             occ_line.occ_06.gotoAndPlay('start');
    //         });
    //     });
    // };

    initSectorPaginate = () => {
        this.defaultPaginateInit(() => {
            const {occ_line, btn_01, btn_02, btn_03, btn_04, btn_05, btn_06, btn_07} = this.getFrame();

            this.setHandleMouseDown(btn_01, () => {
                this.gotoAndStopFrame(occ_line, 1);
                occ_line.occ_01.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_02, () => {
                this.gotoAndStopFrame(occ_line, 2);
                occ_line.occ_02.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_03, () => {
                this.gotoAndStopFrame(occ_line, 3);
                occ_line.occ_03.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_04, () => {
                this.gotoAndStopFrame(occ_line, 4);
                occ_line.occ_04.gotoAndPlay('start');
            });

            // this.setHandleMouseDown(btn_05, () => {
            //     this.gotoAndStopFrame(occ_line, 5);
            //     occ_line.occ_05.gotoAndPlay('start');
            // });

            this.setHandleMouseDown(btn_06, () => {
                this.gotoAndStopFrame(occ_line, 6);
                occ_line.occ_06.gotoAndPlay('start');
            });

            // this.setHandleMouseDown(btn_07, () => {
            //     this.gotoAndStopFrame(occ_line, 7);
            //     occ_line.occ_07.gotoAndPlay('start');
            // });
        });
    };

    initExternal = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {color_icon} = this.props,
                occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
                btn_frame = this.verifyField(_this_current, 'btn_frame01'),
                children = this.verifyField(_this_current, 'occ_frame_03.occ_external.children');

            this.$helpersIcon.disabledAnimate(_this_current)(1, 'frame');

            this.$helpersIcon.setIcon(_this_current, color_icon, 1);

            this.$helpersIcon.setIcon(_this_current, color_icon, 2);

            this.$helpersIcon.setIcon(_this_current, color_icon, 3);

            occ_pseudo_frame && (occ_pseudo_frame.visible = true);

            btn_frame && (btn_frame.visible = false);

            let external = {
                '01': {
                    name: 'ALLTAP',
                    uri: 'https://www.alltap.com.br'
                },
                '02': {
                    name: 'ANIMATE CSS',
                    uri: 'https://animate.style/'
                },
                '03': {
                    name: 'BOOTSTRAP 5',
                    uri: 'https://getbootstrap.com/docs/5.0/getting-started/introduction'
                },
                '04': {
                    name: 'REACT JS',
                    uri: 'https://pt-br.legacy.reactjs.org'
                },
                '05': {
                    name: 'A-FRAME',
                    uri: 'https://aframe.io'
                },
                '06': {
                    name: 'CREATEJS',
                    uri: 'https://createjs.com'
                },
                '07': {
                    name: 'ADOBE ANIMATE',
                    uri: 'https://www.adobe.com/br/products/animate.html'
                }
            }

            if (this.isArrayIf(children)) {
                for (let property of children) {
                    let
                        name = property.name,
                        number = this.toNumber(name),
                        occ = this.padWithLeadingZeros(number, 2);

                    this.openExternal(property, external[occ]);
                }
            }
        }, true);
    };
}

/**
 *
 * @type {{}}
 */
PageCurrent.propTypes = {
    current_name: PropTypes.string,
    frame: PropTypes.number,
    color_icon: PropTypes.string
};

/**
 *
 * @type {{}}
 */
PageCurrent.defaultProps = {
    current_name: null,
    frame: indexConfig.init.frame,
    color_icon: pageConfig.button.color_icon
};

/**
 *
 * @type {{}}
 * @private
 */
PageCurrent._this = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(PageCurrent, {className: 'PageCurrent'});
